import "./BookYourPrivateTransfer.module.css";
import Header from "@/reusable_sections/Header";
import TransferHero from "./sections/TransferHero";
import DirectContact from "./sections/DirectContact";
import BookingForm from "./sections/BookingForm";
import Footer from "@/reusable_sections/Footer";
export default function BookYourPrivateTransferPage() {
  return <div>
      <Header />
      <TransferHero />
      <DirectContact />
      <BookingForm />
      <Footer />
    </div>;
}